import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Dropdown from './Dropdown';
import PageAutoComplete from './PageAutoComplete';
import PageAutoCompleteDropdown from './PageAutoCompleteDropdown';
import RippleButton from 'components/PartnerPage/RippleButton';
import { usePageQuickQuoteContext } from 'contexts/PageQuickQuoteContext';
import { formatLocation } from 'utils/utils.js';
import SwitchIcon from 'components/SwitchIcon';

function PageQuickQuoteForm({
  buttonText = 'Book in less than two minutes', breakText = 'Rates start at $49', allowedOriginLocations, 
  allowedDestinationLocations, toggleOriginDestination, buttonCustomClasses = 'bg-[#4FAB55]'
}) {
  const {
    from, to, product, handleFromSelect, handleToSelect,
    handleProductSelect, handleSubmit, loading, activeProducts, shippingData
    
  } = usePageQuickQuoteContext();

  const isDisabled = !from || !to || !product || loading;

  const [swap, setSwap] = React.useState(0);
  const [debounceInput, setDebounceInput] = React.useState(true)
  const [origins, setOrigins] = React.useState(allowedOriginLocations);
  const [destinations, setDestinations] = React.useState(allowedDestinationLocations);

  const brandSlug = window.gon.current_brand ? window.gon.current_brand : 'shipsticks';

  useEffect(() => {
    if (shippingData) {
      window?.quickQuoteRudderstackEvent([product], from, to, shippingData?.international, shippingData?.rates);
    }
  }, [shippingData]);

  useEffect(() => {
    var originLocations = origins;
    var destinationLocations = destinations;
    var toLocation = to;
    var fromLocation = from;
    if (toLocation && fromLocation) {
      if (swap > 0) {
        setDebounceInput(false)
        setOrigins(destinationLocations)
        setDestinations(originLocations)
        handleFromSelect(toLocation)
        handleToSelect(fromLocation)
      }
    }
  }, [swap] )


  useEffect(() => {
    setDebounceInput(true)
  }, [debounceInput])

  return (
    <form className="w-full" onSubmit={(event) => {
      event.preventDefault();
      if (!loading && product && from && to) {
        handleSubmit();
      }
    }}>
      {origins ? (
        <PageAutoCompleteDropdown
          label="From"
          options={origins}
          onSelect={handleFromSelect}
          value={from}
        />
      ) : (
      <PageAutoComplete
        label="From"
        placeholder="Pickup or drop off location"
        onSelect={handleFromSelect}
        value={formatLocation(from)}
        debounceInput={formatLocation(from) ? false : debounceInput}
      />
      )}
      {toggleOriginDestination && (
        <p className="text-start p-0 mt-[-12px] mb-[-21px]">
          <button onClick={() => setSwap(swap +1)} type="button">
              <SwitchIcon onClick={() => setSwap(swap +1)}  className="cursor-pointer" />
          </button>
        </p>
      )}
      {destinations ? (
        <PageAutoCompleteDropdown
          label="To"
          options={destinations}
          onSelect={handleToSelect}
          value={to}
        />
      ) : (
        <PageAutoComplete
          label="To"
          placeholder="Destination"
          onSelect={handleToSelect}
          value={formatLocation(to)}
          debounceInput={formatLocation(to) ? false : debounceInput}
          />
      )}
      <Dropdown
        label="Product"
        options={activeProducts}
        onSelect={handleProductSelect}
      />

      <div className="w-full flex items-center justify-center my-4 py-2 px-4">
        <div className="flex-grow border-t border-gray-300"></div>
        <span className="mx-4 text-lg text-gray-600 font-bold">
          {breakText}
        </span>
        <div className="flex-grow border-t border-gray-300"></div>
      </div>

      <div className="w-full 2xl:w-3/4 mx-auto px-4 py-3">
        <RippleButton
          className={`
            flex items-center justify-center text-white rounded-full
            py-2 px-4 h-[67px] w-full ${buttonCustomClasses}  bg-${brandSlug}
            ${isDisabled ? 'opacity-50 cursor-not-allowed' : ''}
          `}
            type="submit"
            disabled={isDisabled}
            aria-label={buttonText}
            style={{ transition: 'background-color 0.3s' }}
            >
          <span>{buttonText}</span>
        </RippleButton>
      </div>
    </form>
  );
}

PageQuickQuoteForm.propTypes = {
  allowedOriginLocations: PropTypes.array,
  allowedDestinationLocations: PropTypes.array,
  buttonText: PropTypes.string,
  breakText: PropTypes.string,
  toggleOriginDestination: PropTypes.bool,
  buttonCustomClasses: PropTypes.string
};

export default PageQuickQuoteForm;
